export default __webpack_public_path__ + "static/stock-auto-98fe96fb2c73ad5433628e69c816ae28.jpeg";